<template>
	<div>
		<button
			:class="['c-page-header__button--round', className]"
			id="search-button"
			:aria-expanded="String(showSearchPane)"
			aria-controls="search-pane"
			@click="toggleSearchPane"
		>
			<v-icon name="icon-search" size="s" />
			‍<span class="t-visually-hidden">{{ searchButtonText }}</span>
		</button>
		<Transition name="fade">
			<div v-if="showSearchPane">
				<div class="c-search-pane">
					<form
						class="c-search-pane__input__wrapper o-width-limiter"
						method="get"
						:action="url"
						ref="searchForm"
					>
						<input
							id="search-pane"
							name="q"
							aria-label="huvudsök"
							class="c-search-pane__input"
							type="text"
							ref="searchInput"
							:placeholder="searchPlaceholder"
							@input="handleOnChange"
							autocomplete="off"
							:value="query"
						/>
						<div
							v-if="suggestions.length > 0"
							class="c-search-pane__suggestion-wrapper"
						>
							<ul class="c-search-pane__suggestion-list">
								<li
									v-for="(item, index) in suggestions"
									:key="index"
								>
									<button
										class="c-search-pane__suggestion-item"
										type="button"
										@click.prevent="
											handleSuggestionSelect(item)
										"
										:inner-html.prop="getHighlight(item)"
									></button>
								</li>
							</ul>
						</div>
						<button
							v-if="query"
							class="c-search-pane__clear"
							type="button"
							@click="handleClearInput"
							title="Rensa sökfält"
						>
							<v-icon name="icon-close" size="xs" /> ‍<span
								class="t-visually-hidden"
								>rensa sökfält</span
							>
						</button>
						<button
							class="c-search-pane__button"
							type="submit"
							id="searchpaneSubmitButton"
							@blur="handleFocusout"
						>
							<v-icon name="icon-search" /> ‍<span
								class="t-visually-hidden"
								>{{ performSearchText }}</span
							>
						</button>
					</form>
				</div>
				<div
					class="c-page-header__overlay c-page-header__overlay--search-pane"
				></div>
			</div>
		</Transition>
	</div>
</template>
<script>
import axios from "axios";
import VIcon from "../../components/icon/VIcon.vue";
import VLogo from "../../components/logo/VLogo.vue";

export default {
	name: "VSearchPane",
	components: {
		VLogo,
		VIcon
	},
	props: {
		url: { type: String, default: "" },
		apiUrl: { type: String, default: "" },
		searchButtonText: { type: String, default: "" },
		searchPlaceholder: { type: String, default: "" },
		performSearchText: { type: String, default: "" },
		className: {
			type: String
		},
		isActive: {
			type: Boolean
		}
	},
	data() {
		return {
			loading: false,
			query: "",
			suggestions: []
		};
	},
	mounted() {
		document.addEventListener("click", this.handleClickOutside);
	},
	methods: {
		handleFocusout: function(e) {
			this.toggleSearchPane();
		},

		handleClickOutside: function(e) {
			if (
				e.target.classList.contains(
					"c-page-header__overlay--search-pane"
				)
			) {
				this.toggleSearchPane();
			}
		},
		toggleSearchPane: function(e) {
			//let pageHeader = document.getElementById('pageHeader');
			this.$emit("update:isActive", !this.isActive);
			let body = document.getElementsByTagName("BODY")[0];
			if (!this.isActive) {
				//pageHeader.classList.remove("activated");
				body.classList.add("c-search-pane--open");
			} else {
				body.classList.remove("c-search-pane--open");
			}
		},
		handleOnChange: function(e) {
			this.query = e.target.value;
			this.getSuggestions(e.target.value);
		},

		getSuggestions: function(value) {
			this.loading = true;
			let apiurl = `${this.apiUrl}?q=${value}`;
			axios
				.get(apiurl)
				.then(res => {
					if (res && res.data && res.data.data) {
						this.suggestions = res.data.data;
					}
				})
				.catch(error => console.log(error));
		},
		getHighlight: function(word) {
			var regEx = new RegExp(this.query, "i");
			return word.toString().replace(regEx, function(matched) {
				return (
					"<span class='c-search__highlight'>" + matched + "</span>"
				);
			});
		},
		handleSuggestionSelect: function(item) {
			this.query = item;
			this.suggestions = [];
			setTimeout(() => {
				this.$refs.searchForm.submit();
			}, 300);
		},
		handleClearInput: function(e) {
			e.preventDefault();
			this.query = "";
			this.suggestions = [];
			this.$refs.searchInput.focus();
		}
	},
	computed: {
		showSearchPane() {
			return this.isActive;
		}
	}
};
</script>
